<app-pro-partner-details *ngIf="showProDetails"></app-pro-partner-details>
<app-pro-partner-shows *ngIf="showShows"></app-pro-partner-shows>